import React, { Component } from "react";
import { BrowserRouter, Redirect, Route } from "react-router-dom";
import { UserContext } from "../contexts/configContext";
import Dashboard from "./Dashboard";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import CreateAccount from "./CreateAccount";
import ResetPassword from "./ResetPassword";
import TradeInDetails from "./TradeInDetails";
import VerifyRegistration from "./VerifyRegistration";
import Home from "./Home";
import Header from "../components/Header";
import UserLoadingGate from "../components/UserLoadingGate";
import { StoreProvider } from "../contexts/storeContext";
import { UserProvider } from "../contexts/userContext";

import "../css/App.css";
import "antd/dist/antd.css";
import ResetPasswordVerify from "./ResetPasswordVerify";
import CustomerInformation from "./CustomerInformation";

const isLoggedIn = () => {
  // TEMPORARY: Bypass login for development - remove this in production
  // return true;
  
  // Original login check (commented out temporarily)
  var getUserToken = localStorage.getItem("userId");
  if (getUserToken) {
    return true;
  } else {
    return false;
  }
};

function PrivateRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        authed() ? (
          <>
            <Component {...props} />
          </>
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

class App extends Component {
  render() {
    return (
      <>
        <div className="App">
          <BrowserRouter>
            <StoreProvider page={1} pageSize={10}>
              <UserProvider>
                <UserLoadingGate isAuthenticated={isLoggedIn()}>
                  <Header />
                  <div className="app-body">
              <Route
                exact
                path="/"
                render={() =>
                  !isLoggedIn() ? <Redirect to="/login" /> : <Home />
                }
              />

              <UserContext.Provider value="hello context world">
                <PrivateRoute
                  exact
                  authed={isLoggedIn}
                  path="/dashboard"
                  component={Dashboard}
                />
              </UserContext.Provider>
              <UserContext.Provider value="hello context world">
                <PrivateRoute
                  exact
                  authed={isLoggedIn}
                  path="/TradeInDetails/:tradeinid?"
                  component={TradeInDetails}
                />
              </UserContext.Provider>
              <UserContext.Provider value="hello context world">
                <PrivateRoute
                  exact
                  authed={isLoggedIn}
                  path="/TradeInDetails/:tradeinid/edit-customer-info"
                  component={CustomerInformation}
                />
              </UserContext.Provider>
              <Route exact path="/login" component={Login} />
              <Route exact path="/forgotpassword" component={ForgotPassword} />
              <Route exact path="/createaccount" component={CreateAccount} />
              <Route exact path="/verify" component={VerifyRegistration} />
              <Route
                exact
                path="/verify/resetpassword/:email"
                component={ResetPasswordVerify}
              />
              <Route
                exact
                path="/resetpassword/:token/:email"
                component={ResetPassword}
              />
                  </div>
                </UserLoadingGate>
              </UserProvider>
            </StoreProvider>
          </BrowserRouter>
        </div>
      </>
    );
  }
}

export default App;
